import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { AppService } from '../../../app.service';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { GETSetupEquipmentService } from './setup-equipment.service';
import { CustomerSelectItem, JobsiteSelectItem, EquipmentSelectItem, Equipment } from './setup-equipment.model';
import { Location } from '@angular/common';
import { forkJoin } from "rxjs/observable/forkJoin";

@Component({
  selector: 'setup-equipment',
  templateUrl: './setup-equipment.component.html',
  styleUrls: ['./setup-equipment.component.scss'],
  animations: [
    trigger(
      'fadeInOut', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 0 }),
          animate('0ms', style({ opacity: 0 }))
        ])
      ]
    )],
    
})
export class GETSetupEquipmentComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private _equipmentId: number;
  oldGetUrl: string;
  setupComplete: boolean = false;
  newOrExistingOption: number = 1;
  isLinear = true;
  currentStep: number = 0;

  // Existing Equipment
  existingEquipment: Equipment;
  loadingExistingEquipment: boolean = false;
  updatingEquipment: boolean = false;
  canChangeHoursAndDate: boolean = true; // If the user is editing an equipment that has inspections, this should be false. 

  // Step 1
  customerList: CustomerSelectItem[] = [];
  jobsiteList: JobsiteSelectItem[] = [];
  equipmentList: EquipmentSelectItem[] = [];

  selectedCustomer: number;
  selectedJobsite: number;
  selectedEquipment: number;

  // Step 2
  makeList: JobsiteSelectItem[] = [];
  modelList: JobsiteSelectItem[] = [];

  modelListFilter:JobsiteSelectItem[] = [];

  familyName: string = '';
  serialNumber: string = '';
  unitNumber: string = '';
  selectedMake: number;
  selectedModel: number;
  smuAtSetup: number = 0;
  ltdAtSetup: number = 0;
  dateOfReading: Date = new Date();
  imageUrl: string = '';
  serialUnitValid: boolean = true;
  isValidating: boolean = true;
  smuLtdGreaterThanZero: boolean = true;
  ltdGreaterThanSmu: boolean = true;
  bcmAtSetup:number;
  tonAtSetup:number;

  // Step 3
  rankingList: CustomerSelectItem[] = [];
  applicationList: CustomerSelectItem[] = [];
  statusList = [
    { Id: 0, Name: 'Not in Use' },
    { Id: 1, Name: 'In Use' },
    { Id: 2, Name: 'Parked' },
    { Id: 3, Name: 'Rental' },
    { Id: 4, Name: 'Single Inspection' }
  ];
  unitList = [
    { Id: 0, Name: 'Hours' },
    { Id: 1, Name: 'Days' }
  ];

  forecastingList = [
    { Id: 0, Name: 'Off' },
    { Id: 1, Name: 'On' }
  ];
  selectedApplication: number;
  selectedRanking: number;
  selectedStatus: number = 1;
  selectedInspectEveryUnit: number = 0;
  inspectEvery: number = 500;
  hoursUsePerDay: number = 16;
  monCheck: boolean = true;
  tueCheck: boolean = true;
  wedCheck: boolean = true;
  thuCheck: boolean = true;
  friCheck: boolean = true;
  satCheck: boolean = false;
  sunCheck: boolean = false;
  creatingEquipment: boolean = false;
  selectedForecast: number = 0;
  InspectionCount: number = 0;
  //minDate: Date = new Date();
  //maxDate: Date = new Date();

  constructor(private _appService: AppService,
    private _ref: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _equipmentService: GETSetupEquipmentService,
    private _router: Router,
    private _location: Location) { }

  ngOnInit() {
    //this.dateOfReading.setMonth(this.dateOfReading.getMonth() - 3);
    this._appService.setPageTitle('Setup Equipment');
   // this._appService.setPageSubTitle('Setup your new equipment first and then attach your GET to it so you can start recording inspections. ')
    this._equipmentId = this._route.snapshot.params.id;
    if (this._equipmentId != null) // If an equipment id has been passed in through the URL
      this.loadExistingEquipment();
    else // If theere is no equipment id being passed in
      this.loadStepOne();
    // this._appService.getApplicationConfigValue().subscribe(getUrl => {
    //   this.oldGetUrl = getUrl;
    // });

    //this.setMinDateForEquipment();  
    //this.maxDate.setDate(this.maxDate.getDate() + 1);
  }

  //setMinDateForEquipment() {
  //    this._equipmentService.getMinDateForEquipmentSetup(this._equipmentId).subscribe(res => {
  //        if (res != null) {
  //            this.minDate = new Date(res);
  //        }
  //    });
  //}

  clearInputs() {
    this.familyName = '';
    this.serialNumber = '';
    this.unitNumber = '';
    this.selectedMake = -1;
    this.selectedModel = -1;
    this.machineModel='';
    this.smuAtSetup = 0;
    this.ltdAtSetup = 0;
    this.dateOfReading = new Date();
    this.imageUrl = '';
    this.serialUnitValid = true;
    this.isValidating = true;
    this.selectedApplication = -1;
    this.selectedRanking = -1;
    this.selectedStatus = 1;
    this.selectedForecast = 0;
    this.selectedInspectEveryUnit = 0;
    this.inspectEvery = 500;
    this.hoursUsePerDay = 16;
    this.monCheck = true;
    this.tueCheck = true;
    this.wedCheck = true;
    this.thuCheck = true;
    this.friCheck = true;
    this.satCheck = false;
    this.sunCheck = false;
    this.canChangeHoursAndDate = true;
    this.creatingEquipment = false;
  }

  loadExistingEquipment() {
    this.loadingExistingEquipment = true;
    this._subscriptions.push(this._equipmentService.getEquipmentSetupDetails(this._equipmentId).subscribe(equipment => {
      let customers = this._equipmentService.getCustomerList();
      let jobsites = this._equipmentService.getJobsiteList(equipment.CustomerId);
      let equipmentList = this._equipmentService.getEquipmentList(equipment.JobsiteId);
      let makeList = this._equipmentService.getMakeList();
      let modelList = this._equipmentService.getModelList(equipment.MakeId);

      let familyName = this._equipmentService.getFamilyNameForModel(equipment.ModelId);
      let applicationList = this._equipmentService.getEquipmentApplicationList();
      let rankingList = this._equipmentService.getEquipmentRankingList();
     
      if (equipment.CanChangeSmuLtd)
        this.canChangeHoursAndDate = true;
      else
        this.canChangeHoursAndDate = false;
      this._subscriptions.push(forkJoin([customers, jobsites, equipmentList, makeList, modelList, familyName, applicationList, rankingList]).subscribe((r: any) => {
        this.customerList = r[0];
        this.jobsiteList = r[1];
        this.equipmentList = r[2];
        this.makeList = r[3];
        this.modelList = r[4];
        this.modelListFilter = r[4];

        let mName = this.modelList.find(f => f.Id == equipment.ModelId).Name
        this.machineModel = mName;


        this.familyName = r[5];
        this.applicationList = r[6];
        this.rankingList = r[7];
        this.selectedCustomer = equipment.CustomerId;
        this.selectedJobsite = equipment.JobsiteId;
        this.selectedEquipment = equipment.Id;
        this.selectedMake = equipment.MakeId;
        this.selectedModel = equipment.ModelId;


        this.selectedApplication = equipment.ApplicationId;
        this.selectedRanking = equipment.RankingId;
        this.dateOfReading = new Date(equipment.Date);
        this.hoursUsePerDay = equipment.HoursOfUsePerDay;
        this.inspectEvery = equipment.InspectEvery;
        this.selectedInspectEveryUnit = equipment.InspectEveryUnitTypeId;
        this.ltdAtSetup = equipment.Ltd;
        this.serialNumber = equipment.SerialNumber;
        this.selectedForecast = equipment.ForecastId;
        this.smuAtSetup = equipment.Smu;
        this.unitNumber = equipment.UnitNumber;
        this.monCheck = equipment.UsedMonday;
        this.tueCheck = equipment.UsedTuesday;
        this.wedCheck = equipment.UsedWednesday;
        this.thuCheck = equipment.UsedThursday;
        this.friCheck = equipment.UsedFriday;
        this.satCheck = equipment.UsedSaturday;
        this.sunCheck = equipment.UsedSunday;
        this.newOrExistingOption = 2;
        this.serialUnitValid = true;
        this.isValidating = false;
        this.imageUrl = equipment.Photo?'data:image/png;base64,' + equipment.Photo:"";
        this.loadingExistingEquipment = false;
       

        if( equipment.Ton == -1)
        this.tonAtSetup =undefined
        else
        this.tonAtSetup =equipment.Ton;
        if( equipment.Bcm == -1)
        this.bcmAtSetup =undefined
        else
        this.bcmAtSetup =equipment.Bcm;
      } ));
    }));
  }

  onSelectEquipment() {
    if (this.selectedEquipment != null) {
      this._equipmentId = this.selectedEquipment;
      //this._router.navigate(['setup-equipment', this.selectedEquipment]);
      this._location.go('setup/get-equipment/' + this.selectedEquipment);
      this.clearInputs();
      this.loadExistingEquipment();
      //this.setMinDateForEquipment();
    }
  }

  onNewEquipment() {
    this._router.navigate(['setup/get-equipment']); 
    this.clearInputs();
  }

  loadStepOne() {
    this._subscriptions.push(this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
    }));
  }

  navigateToSetupNewEquipment() {
    this._router.navigate(['setup/get-equipment']);
    this._equipmentId = null;
    this.setupComplete = false;
    this.newOrExistingOption = 1;
    this.currentStep = 0;
    this.clearInputs();
    this._subscriptions.push(this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(equipmentList => {
      this.equipmentList = equipmentList;
    }));
  }

  navigateToSetupImplements() {
    //this._router.navigate(['setup/implement',  this._equipmentId]);
    this._router.navigate(['setup/implement-new',  this._equipmentId]);
  }

  validateSerialAndUnit() {
    this.isValidating = true;
    this._subscriptions.push(this._equipmentService.validateEquipmentSerialAndUnit(this.serialNumber, this.unitNumber, this._equipmentId != null ? this._equipmentId : 0).subscribe(r => {
      this.serialUnitValid = r;
      this.isValidating = false;
    }));
  }



  validateSmuAndLtd() {
    if (this.smuAtSetup < 0 || this.ltdAtSetup < 0)
      this.smuLtdGreaterThanZero = false;
    else
      this.smuLtdGreaterThanZero = true;

    if (this.smuAtSetup > this.ltdAtSetup){
      this.ltdAtSetup = this.smuAtSetup
    }
     // this.ltdGreaterThanSmu = false;
    else this.ltdGreaterThanSmu = true;
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.selectedJobsite = null;
    this.jobsiteList = [];
    this.selectedEquipment = null;
    this.equipmentList = [];
    this._subscriptions.push(this._equipmentService.getJobsiteList(this.selectedCustomer).subscribe(r => {
      this.jobsiteList = r;
    }));
  }

  loadEquipmentForJobsite() {
    if (this.selectedJobsite == null)
      return;
    this._subscriptions.push(this._equipmentService.getEquipmentList(this.selectedJobsite).subscribe(r => {
      this.equipmentList = r;
    }));
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }

  onUpdateEquipmentClick() {
    if (!this.stepTwoIsValid() || !this.stepThreeIsValid())
      return;
    this.updatingEquipment = true;
console.log("this.imageUrl",this.imageUrl)
    let e = new Equipment();
    e.Id = this.selectedEquipment;
    e.ApplicationId = this.selectedApplication;
    e.CustomerId = this.selectedCustomer;
    e.Date = this.dateOfReading;
    e.HoursOfUsePerDay = this.hoursUsePerDay;
    e.InspectEvery = this.inspectEvery;
    e.InspectEveryUnitTypeId = this.selectedInspectEveryUnit;
    e.JobsiteId = this.selectedJobsite;
    e.Ltd = this.ltdAtSetup;
    e.MakeId = this.selectedMake;
    e.ModelId = this.selectedModel;
    e.Photo = this.imageUrl;
    e.RankingId = this.selectedRanking;
    e.SerialNumber = this.serialNumber;
    e.Smu = this.smuAtSetup;
    e.StatusId = this.selectedStatus;
    e.ForecastId = this.selectedForecast;
    e.UnitNumber = this.unitNumber;
    e.UsedMonday = this.monCheck;
    e.UsedTuesday = this.tueCheck;
    e.UsedWednesday = this.wedCheck;
    e.UsedThursday = this.thuCheck;
    e.UsedFriday = this.friCheck;
    e.UsedSaturday = this.satCheck;
    e.UsedSunday = this.sunCheck;
    e.SetupDate = this.getFormatedDate(new Date(this.dateOfReading));
    if(this.bcmAtSetup ==undefined)
    e.Bcm = -1;
    else
    e.Bcm = this.bcmAtSetup;
    if(this.tonAtSetup ==undefined)
    e.Ton = -1;
    else
    e.Ton=this.tonAtSetup;
    

    this._subscriptions.push(this._equipmentService.updateEquipment(e).subscribe(r => {
      console.log(r);
      this.updatingEquipment = false;
      this._equipmentId = r.m_Item1;
      this.setupComplete = true;
    }));
  }

  getFormatedDate = (currentDate) => {
  
    console.log("curernt ", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };
  onCreateNewEquipmentClick() {
    if (!this.stepTwoIsValid() || !this.stepThreeIsValid())
      return;
    this.creatingEquipment = true;

    
    let e = new Equipment();
    e.ApplicationId = this.selectedApplication;
    e.CustomerId = this.selectedCustomer;
    e.Date = this.dateOfReading;
    e.HoursOfUsePerDay = this.hoursUsePerDay;
    e.InspectEvery = this.inspectEvery;
    e.InspectEveryUnitTypeId = this.selectedInspectEveryUnit;
    e.JobsiteId = this.selectedJobsite;
    e.Ltd = this.ltdAtSetup;
    e.MakeId = this.selectedMake;
    e.ModelId = this.selectedModel;
    e.Photo = this.imageUrl;
    e.RankingId = this.selectedRanking;
    e.SerialNumber = this.serialNumber;
    e.Smu = this.smuAtSetup;
    e.StatusId = this.selectedStatus;
    e.ForecastId = this.selectedForecast;
    e.UnitNumber = this.unitNumber;
    e.UsedMonday = this.monCheck;
    e.UsedTuesday = this.tueCheck;
    e.UsedWednesday = this.wedCheck;
    e.UsedThursday = this.thuCheck;
    e.UsedFriday = this.friCheck;
    e.UsedSaturday = this.satCheck;
    e.UsedSunday = this.sunCheck;
    e.SetupDate = this.getFormatedDate(new Date(this.dateOfReading));
    

    if(this.bcmAtSetup ==undefined)
    e.Bcm = -1;
    else
    e.Bcm = this.bcmAtSetup;
    if(this.tonAtSetup ==undefined)
    e.Ton = -1;
    else
    e.Ton=this.tonAtSetup;
    
    console.log("model",e)
    this._subscriptions.push(this._equipmentService.createNewEquipment(e).subscribe(r => {
      console.log(r);
      if (r.m_Item1 <= 0) {
        this.creatingEquipment = false;
      } else {
        this.creatingEquipment = false;
        this._equipmentId = r.m_Item1;
        this.setupComplete = true;
      }
    }));
  }

  goToStep(step: number) {
    console.log(step, this.selectedCustomer, this.selectedJobsite, this.selectedEquipment, this.newOrExistingOption);
    console.log(step, this.serialNumber, this.unitNumber, this.selectedMake, this.selectedModel, this.smuAtSetup, this.ltdAtSetup);
    switch (step) {
      case 1:
        if (this.stepTwoIsValid()) {
          this.currentStep = 1;
          this.loadMakes();
        }
        break;
      case 2:
        if (this.stepThreeIsValid()) {

          console.log("2")
          this.currentStep = 2;
          this.loadingApplicationList();
          this.loadRankingList();
        }
        break;
    }
  }

  stepTwoIsValid(): boolean {
    return (this.selectedCustomer > 0 && this.selectedJobsite > 0 && ((this.newOrExistingOption == 2 && this.selectedEquipment > 0) || this.newOrExistingOption == 1));
  }

  stepThreeIsValid(): boolean {
    return (this.smuLtdGreaterThanZero && this.ltdGreaterThanSmu && this.serialNumber != '' && this.unitNumber != '' && this.selectedMake > 0 && this.selectedModel > 0 && this.smuAtSetup >= 0 && this.ltdAtSetup >= 0 && this.serialUnitValid && !this.isValidating && !isNaN(new Date( this.dateOfReading).getTime()));
  }

  goBackStep(step: number) {
    this.currentStep--;
  }

  loadingApplicationList() {
    this._subscriptions.push(this._equipmentService.getEquipmentApplicationList().subscribe(r => {
      console.log("r",r)
      this.applicationList = r;
      this.selectedApplication = r[r.findIndex(i => i.Name.toLowerCase() == 'mining')].Id;
    }));
  }

  loadRankingList() {
    this._subscriptions.push(this._equipmentService.getEquipmentRankingList().subscribe(r => {
      this.rankingList = r;
    }));
  }

  loadMakes() {
    this._subscriptions.push(this._equipmentService.getMakeList().subscribe(r => {
      this.makeList = r;
    }));
  }

  loadModelsForMake() {
    if (this.selectedMake == null)
      return;
    this.modelList = [];
    this.selectedModel = null;
    this.familyName = '';
    this.machineModel='';
    this._subscriptions.push(this._equipmentService.getModelList(this.selectedMake).subscribe(r => {
      this.modelList = r;
      this.modelListFilter=r;
    }));
  }

  loadFamilyNameForModel() {
    this._subscriptions.push(this._equipmentService.getFamilyNameForModel(this.selectedModel).subscribe(r => {
      this.familyName = r;
    }));
  }

  onSelectEquipmentPhoto(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        this.imageUrl = event.target["result"];
      }
    }
  }


  modelTitle: string = "";
  model_auto_: number;

  machineModel: string = "";
  onSelcetionModel(event: any) {
    let id = this.modelList.find(f => f.Name == event.value).Id
    this.selectedModel = id;

    this.loadFamilyNameForModel();
  }
  changedModel(event: any) {
    if (event.target.value != "") {
      const filterValue = event.target.value.toLowerCase();
      this.modelList = this.modelList.filter(option => option.Name.toLowerCase().includes(filterValue));
    }
    else {
      this.resetModel();
    }
  }

  resetModel() {
    this.selectedModel = 0;
    this.modelList = this.modelListFilter;
  }
}

interface FileReaderEventTarget extends EventTarget {
  result: string
}

interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}
